const SUPPORT_CHAT_SCRIPT_ID = 'salesmartly-chat-sdk'
const SUPPORT_CHAT_SCRIPT_SRC = 'https://plugin-code.salesmartly.com/js/project_437174_450056_1756359426.js'
const ANTOM_PAYMENT_ROUTE_PREFIX = '/payment/antom'

let supportChatPromise = null

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

function resolveRoutePath(routeOrPath) {
  if (!routeOrPath) {
    return ''
  }
  if (typeof routeOrPath === 'string') {
    return routeOrPath
  }
  if (typeof routeOrPath === 'object') {
    return routeOrPath.path || routeOrPath.fullPath || ''
  }
  return String(routeOrPath)
}

function resolveSupportChatApi() {
  if (!isBrowser() || typeof window.ssq !== 'function') {
    return null
  }
  return window.ssq
}

function resolveExistingScript() {
  return document.getElementById(SUPPORT_CHAT_SCRIPT_ID)
}

function buildSupportChatLoginInfo(userInfo = {}) {
  return {
    user_id: userInfo.id,
    user_name: userInfo.nickName,
    language: 'en-US',
    email: userInfo.email
  }
}

export function isAntomPaymentRoute(routeOrPath) {
  return resolveRoutePath(routeOrPath).startsWith(ANTOM_PAYMENT_ROUTE_PREFIX)
}

export function updateSupportChatUser(userInfo) {
  const supportChatApi = resolveSupportChatApi()
  if (!supportChatApi || !userInfo || !userInfo.id) {
    return
  }
  supportChatApi('setLoginInfo', buildSupportChatLoginInfo(userInfo))
}

export function ensureSupportChatLoaded(routeOrPath) {
  if (!isBrowser() || isAntomPaymentRoute(routeOrPath)) {
    return Promise.resolve(null)
  }

  const existingScript = resolveExistingScript()
  const supportChatApi = resolveSupportChatApi()
  if (existingScript && supportChatApi) {
    existingScript.dataset.loaded = 'true'
    return Promise.resolve(supportChatApi)
  }
  if (supportChatPromise) {
    return supportChatPromise
  }

  supportChatPromise = new Promise((resolve, reject) => {
    const handleReady = (script) => {
      const resolvedSupportChatApi = resolveSupportChatApi()
      if (!resolvedSupportChatApi) {
        reject(new Error('Salesmartly support chat initialized but ssq API is unavailable'))
        return
      }
      script.dataset.loaded = 'true'
      resolve(resolvedSupportChatApi)
    }

    const handleScriptError = () => {
      reject(new Error('Failed to load Salesmartly support chat'))
    }

    if (existingScript) {
      existingScript.addEventListener('load', () => handleReady(existingScript), { once: true })
      existingScript.addEventListener('error', handleScriptError, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = SUPPORT_CHAT_SCRIPT_ID
    script.src = SUPPORT_CHAT_SCRIPT_SRC
    script.async = true
    script.onload = () => handleReady(script)
    script.onerror = handleScriptError
    document.head.appendChild(script)
  }).catch((error) => {
    supportChatPromise = null
    throw error
  })

  return supportChatPromise
}

export async function openSupportChat(routeOrPath, userInfo) {
  try {
    const supportChatApi = await ensureSupportChatLoaded(routeOrPath)
    if (!supportChatApi) {
      return false
    }
    updateSupportChatUser(userInfo)
    supportChatApi('chatOpen')
    return true
  } catch (error) {
    console.error('Failed to open support chat:', error)
    return false
  }
}
